import { Db } from 'mongodb'
import { schema, types } from 'papr'

export const emailDeliverySchema = schema(
	{
		deliveryId: types.string({ required: true }),
		publication: types.objectId(),
		email: types.string(),
		hasClicked: types.boolean(),
		hasOpened: types.boolean(),
		dateAdded: types.date(),
		messageId: types.string(),
		unsubscribeCode: types.string(),
	},
	{
		timestamps: true,
		defaults: {
			hasClicked: false,
			hasOpened: false,
		},
	},
)

export const createEmailDeliveriesIndex = async (db: Db) => {
	await db.createIndex('emaildeliveries', {
		deliveryId: 1,
	})
}

export type EmailDeliveryDocument = (typeof emailDeliverySchema)[0]
export type EmailDeliverySchemaOptions = (typeof emailDeliverySchema)[1]
